import React from 'react'
import { put, call, select } from 'redux-saga/effects'
import ProductActions from '../store/productRedux'
import { toast, Slide } from 'react-toastify'
import HrbTranslate from '../components/language/HrbTranslate'

export const getAuth = state => state.auth

export function* getDiyReturn(api, action) {
    try {
        var response = yield call(api.getProduct, action);

        if (response.ok && response.status === 200) {
            yield put(ProductActions.setSelectedDiyReturn(response.data))
        } else {
            yield put(ProductActions.setSelectedDiyReturn(null))
        }
    } catch (ex) {
        console.log(ex)
    }
}

export function* getExpertReview(api, action) {
    try {
        var response = yield call(api.getExpertReview, action)
        if (response.ok && response.status === 200) {
            yield put(ProductActions.setExpertReview(response.data))
        }        
        else {
            yield put(ProductActions.setExpertReview(null))
        }
    }
    catch (ex) {
        console.log(ex)
        yield put(ProductActions.setExpertReview(null))
    }    
}

export function* getAuditProtection(api, action) {
    try {
        var response = yield call(api.getAuditProtection, action)
        if (response.ok && response.status === 200) {
            yield put(ProductActions.setAuditProtection(response.data))
        }
        else if (response.ok && response.status === 204) {
            yield put(ProductActions.setAuditProtection(null))
        }
        else {
            yield put(ProductActions.setAuditProtection(null))
        }
    }
    catch (ex) {
        console.log(ex)
        yield put(ProductActions.setAuditProtection(null))
    }
    
}

export function* getPresale(api, action) {
    try {
        var response = yield call(api.getPresale, action.data.id, action.data.taxYear)
        if (response.ok && response.status === 200) {
            yield put(ProductActions.setSelectedPresale(response.data))
        }
        else {
            yield put(ProductActions.setSelectedPresale(null))
        }
    } catch (ex) {
        console.log(ex)
    }
}

export function* getSelectedOte(api, action) {
    var response = yield call(api.getOte, action.data)
    if (response.ok && response.status === 200) {
        yield put(ProductActions.setSelectedOte(response.data))
    }
    else {
        yield put(ProductActions.setSelectedOte(null))
    }
}

export function* getActivationCodes(api, action) {
    try {
        var response = yield call(api.getActivationCodes, action.viewModelId, action.taxYear, action.clientId)
        if (response.ok && response.status === 200) {
            yield put(ProductActions.setActivationCodes(response.data))
        }
        else {
            yield put(ProductActions.setActivationCodes([]))
        }
    } catch (e) {
        console.debug(e);
    }
}

export function* getFiledReturn(api, action) {
    try {
        var response = yield call(api.getFiledReturn, action)
        if (response.ok && response.status === 200) {
            const el = document.createElement('textarea');
            el.value = response.data;
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
            toast.success(<HrbTranslate text='ToastLabels.CopiedToClipboard' />, { className: 'black-background-toast', position: "bottom-left", autoClose: 5000, transition: Slide, hideProgressBar: true, closeOnClick: true, pauseOnHover: true, draggable: true });
        }
        else {
            toast.error('Failed', { className: 'black-background-toast', position: "bottom-left", autoClose: 5000, transition: Slide, hideProgressBar: true, closeOnClick: true, pauseOnHover: true, draggable: true });
        }
        yield put(ProductActions.removeDataRetrievalId(action.fileId))

    } catch (e) {
        console.debug(e);
    }
}
